import { render, staticRenderFns } from "./ServerFailedPopup.vue?vue&type=template&id=4076773a&"
import script from "./ServerFailedPopup.vue?vue&type=script&lang=js&"
export * from "./ServerFailedPopup.vue?vue&type=script&lang=js&"
import style0 from "./ServerFailedPopup.vue?vue&type=style&index=0&id=4076773a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports